import { useQuery, } from "@tanstack/react-query";
import { upcomingPaymentsQueryConfig, } from "../../../../../api";

export function useUpcomingPayment() {
  const upcomingPayments = useQuery(upcomingPaymentsQueryConfig(),);

  return {
    upcomingPayments,
  };
}
